import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';

import SectionTypeList from '../SectionTypeList';
import {
  SectionsListContainer,
  SectionsListTitle,
  DesktopComponent,
} from '../styledComponents';

import { SectionTree, SectionTypeTree } from 'types/common';

type SectionsListProps = {
  currentSection?: string;
  isPos?: boolean;
  sectionTree: SectionTree;
  sectionTypeTree: SectionTypeTree;
};

const SectionsList: FC<SectionsListProps> = ({
  currentSection = '',
  isPos = false,
  sectionTree = {},
  sectionTypeTree = {},
}) => {
  const { t } = useTranslation();

  return (
    <DesktopComponent>
      {Object.keys(sectionTypeTree).map((sectionType) => (
        <SectionsListContainer span="12" skip="0" key={sectionType}>
          {isPos ? null : (
            <SectionsListTitle size="one" variant="highlight">
              {t(`common.browse_by.${sectionType.toLowerCase()}`)}
            </SectionsListTitle>
          )}
          <SectionTypeList
            sectionTree={sectionTree}
            sectionType={sectionType}
            currentSection={currentSection}
            sectionTypeTree={sectionTypeTree}
            isPos={isPos}
          />
        </SectionsListContainer>
      ))}
    </DesktopComponent>
  );
};

export default SectionsList;
